export default __webpack_public_path__ + "static/media/spark_80.499e0833.png";